import { PAYMENT_METHOD, RECIPIENT_TYPES } from 'components/common/constants';

export default function UpdateTemplateModel(apiTemplate) {
  if (!apiTemplate) return {};

  const {
    templateName,
    templateId,
    amount,
    currency,
    comment,
    paymentMethod,
    paymentPurpose,
    requisites = {},
    beneficiary = {}
  } = apiTemplate;

  // AccountDetailsStep
  const accountDetails = {
    currency: currency || null,
    accountNumber: requisites?.iban || requisites?.cryptoAddress || requisites?.accountNumber || null,
    sortCode: requisites.sortCode || null,
    network: requisites.cryptoNetwork || null
  };

  // BankDetailsStep
  const bankDetails = {
    bankName: requisites.bankName || null,
    bankCountry: requisites.bankCountry || null,
    bic: requisites.bic || null,
    paymentPurpose: paymentPurpose || null
  };

  // PaymentDetailsStep
  const paymentDetails = {
    amount: amount?.toString() || null,
    transferDetails: comment || null
  };

  // RecipientDetailsStep
  const recipientDetails = {
    recipientType: beneficiary.type === 'CORPORATE' ? RECIPIENT_TYPES.COMPANY : RECIPIENT_TYPES.INDIVIDUAL,
    companyName: beneficiary.companyName || null,
    firstName: beneficiary.firstName || null,
    lastName: beneficiary.lastName || null
  };

  const recipientAdditionalDetails = {
    registrationNumber: beneficiary.registrationNumber || null,
    country: beneficiary.country || null,
    city: beneficiary.city || null,
    postCode: beneficiary.postCode || null,
    address: beneficiary.address || null
  };

  const iban = requisites.iban || null;

  const cryptoAddress = requisites.cryptoAddress || null;

  return {
    templateName: templateName || null,
    templateId: templateId || null,
    paymentMethod: paymentMethod || null,
    paymentPurpose: paymentPurpose || null,
    ...accountDetails,
    ...bankDetails,
    ...paymentDetails,
    ...recipientDetails,
    ...recipientAdditionalDetails,
    iban,
    cryptoAddress,
    isCryptoPayment: paymentMethod === PAYMENT_METHOD.CRYPTO
  };
}
